import { InstallPrompt } from '@/components/pwa/install-prompt'
import { PushNotificationPrompt } from '@/components/push/push-notification-prompt'
import { useTheme } from '@/lib/hooks/use-theme'
import { useAppDispatch, useAuth } from '@/store/hooks'
import { logout } from '@/store/slices/authSlice'
import React, { useEffect, useState } from 'react'
import { Outlet, useNavigate } from 'react-router-dom'
import { AdminNavbar } from '../admin/admin-navbar'
import { MasterSidebar } from './master-sidebar'

export const MasterLayout = () => {
    const [sidebarOpen, setSidebarOpen] = useState(false)
    const theme = useTheme()

    const { user, isAuthenticated, token, isMaster } = useAuth()
    const navigate = useNavigate()

    const dispatch = useAppDispatch()

    useEffect(() => {
        if (!isMaster) {
            dispatch(logout())
            navigate('/login')
        }
    }, [isMaster])

    if (!isAuthenticated || !user || !token || !isMaster) {
        return null
    }



    return (
        <React.Fragment>
            <div
                data-theme={theme}
                className="flex h-screen overflow-hidden"
            >
                <div className="hidden lg:block">
                    <MasterSidebar />
                </div>
                {sidebarOpen && (
                    <div className="lg:hidden fixed inset-0 z-50">
                        <div
                            className="fixed inset-0 bg-black/50"
                            onClick={() => setSidebarOpen(false)}
                        ></div>
                        <div className="fixed left-0 top-0 bottom-0 z-50 shadow-2xl">
                            <MasterSidebar
                                onItemClick={() => setSidebarOpen(false)}
                            />
                        </div>
                    </div>
                )}
                <div className="flex flex-col flex-1 overflow-hidden">
                    <AdminNavbar
                        onMenuClick={() => setSidebarOpen(!sidebarOpen)}
                    />
                    <main className="flex-1 overflow-y-auto ">
                        <div className="p-6 !max-w-[1300px] mx-auto">
                            <Outlet />
                        </div>
                    </main>
                </div>
            </div>
            <InstallPrompt />
            <PushNotificationPrompt />
        </React.Fragment>
    )
}
